import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsAssessmentTeacherAPIServiceV6 } from '@protos/learning_management/lms.assessment.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransportWithLogoutHandler,
} from './transports';

export const useLmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAssessmentTeacherAPIServiceV6,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
